/* istanbul ignore file */
import { FormikConsumer, FormikContextType } from "formik";
import React, { ReactElement, useContext } from "react";
import { __RouterContext } from "react-router";
import { ISWAsyncCondition, ISWSideEffect, ISWSideEffectWithContext } from "./isw-types";
import { useISWSideEffects } from "./use-isw-side-effects";

type FormikSideEffectProps<T> = {
  sync?: ISWSideEffect<T> | ISWSideEffectWithContext<T, any>;
  async?: ISWAsyncCondition<T, any>;
  runOnFirstRender?: boolean;
  disablePlatformApiFoutenHandler?: boolean;
  asyncStartStopCallback?: React.Dispatch<React.SetStateAction<boolean>>;
};

const ISWSideEffectChild = <T extends {}>({
  formik,
  sync,
  async,
  runOnFirstRender,
  disablePlatformApiFoutenHandler,
  asyncStartStopCallback: startStopDispatch
}: FormikSideEffectProps<T> & {
  formik: FormikContextType<T>;
}): null => {
  useISWSideEffects<T>(formik, sync, async, runOnFirstRender, disablePlatformApiFoutenHandler, startStopDispatch);

  return null;
};

export const ISWSideEffects = <T extends {}>({
  sync,
  async,
  runOnFirstRender,
  disablePlatformApiFoutenHandler,
  asyncStartStopCallback: startStopDispatch
}: FormikSideEffectProps<T>): ReactElement => {
  const hasRouterContext = useContext(__RouterContext);

  if (!hasRouterContext) throw new Error("Component must be inside a react-router context to use ISWSideEffects");

  return (
    <FormikConsumer>
      {formik => (
        <ISWSideEffectChild
          disablePlatformApiFoutenHandler={disablePlatformApiFoutenHandler}
          sync={sync}
          async={async}
          runOnFirstRender={runOnFirstRender}
          formik={formik}
          asyncStartStopCallback={startStopDispatch}
        />
      )}
    </FormikConsumer>
  );
};
